// @flow

import React, { type Node, useEffect, useRef, useState } from 'react';

import spaceSrc from './space.jpg';
import { componentFactory } from '../component-factory';

type Props = {|
  children: Node,
|};

export function Space({ children }: Props): Node {
  const [ ref, mouseX, mouseY ] = useMouseMove();
  return (
    <Wrapper ref={ref}>
      <Background mouseX={mouseX} mouseY={mouseY} />
      {children}
    </Wrapper>
  );
}

const Wrapper = componentFactory('div', () => ({
  width: '100%',
  overflow: 'hidden',
  position: 'relative',
  padding: '32px 0',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

const Background = componentFactory('div', ({ mouseX, mouseY }) => ({
  position: 'absolute',
  width: '100%',
  height: '100%',
  backgroundImage: `url('${spaceSrc}')`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  filter: 'grayscale(.4)',
  transform: `scale(1.6) translate(${mouseX}%, ${mouseY}%)`,
}));

function useMouseMove(): [{ current: ?HTMLElement }, number, number] {
  const [clientX, setClientX] = useState<number>(0);
  const [clientY, setClientY] = useState<number>(0);

  const ref = useRef<?HTMLElement>(null);

  const handleMouseMove = (event: MouseEvent) => {
    const { current } = ref;
    if (current) {
      setClientX((event.pageX - current.offsetLeft) / current.clientWidth);
      setClientY((event.pageY - current.offsetTop) / current.clientHeight);
    }
  };

  useEffect(() => {
    const { current } = ref;
    if (current) {
      current.addEventListener('mousemove', handleMouseMove);
      return () => current.removeEventListener('mousemove', handleMouseMove);
    }
  }, [ref]);

  return [
    ref,
    clientX,
    clientY,
  ];
}
